/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newpatient_Privacyconsentprefix3Inputs */

const en_newpatient_privacyconsentprefix3 = /** @type {(inputs: Newpatient_Privacyconsentprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I agree to the collection and use of my information as described in the `)
};

const fr_newpatient_privacyconsentprefix3 = /** @type {(inputs: Newpatient_Privacyconsentprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J'accepte la collecte et l'utilisation de mes informations telles que décrites dans la `)
};

/**
* | output |
* | --- |
* | "I agree to the collection and use of my information as described in the" |
*
* @param {Newpatient_Privacyconsentprefix3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const newpatient_privacyconsentprefix3 = /** @type {((inputs?: Newpatient_Privacyconsentprefix3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newpatient_Privacyconsentprefix3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newpatient_privacyconsentprefix3(inputs)
	return fr_newpatient_privacyconsentprefix3(inputs)
});
export { newpatient_privacyconsentprefix3 as "newPatient_privacyConsentPrefix" }